import React from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import BottomSheetDialog from "./mobile-bottom-sheet";

export interface DeletePopupProps {
    open: boolean;
    image?: { src: string; width?: number; height?: number };
    message?: string;
    red?: boolean;
    description?: string;
    footer?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    onConfirm: () => void;
    onCancel: () => void;
    zIndex?: number;
    loading?: boolean;
}

// Bottom-sheet phone equivalent of delete.tsx - same confirm/cancel
// contract, sized to its own content (fitContent) rather than a fixed
// height, since this is just a message + two buttons.
const DeletePopupMobile: React.FC<DeletePopupProps> = ({
    open,
    image,
    message = "Are you sure?",
    red = false,
    footer,
    description = "This action cannot be undone.",
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    onConfirm,
    onCancel,
    loading = false,
}) => (
    <BottomSheetDialog open={open} onClose={onCancel} fitContent heightVh={70}>
        <Box sx={{ p: 3, textAlign: 'center' }}>
            {image && (
                <Box mb={2} display="flex" justifyContent="center">
                    <img
                        src={image.src}
                        width={image.width || 140}
                        height={image.height || 120}
                        alt="delete"
                        style={{ objectFit: 'contain', maxWidth: '100%' }}
                    />
                </Box>
            )}
            <Typography variant="h6" fontWeight={700} mb={1.5} color={red ? "#F44336" : "inherit"}>
                {message}
            </Typography>
            <Typography
                color="text.secondary"
                fontSize={15}
                mb={3}
                component="div"
                dangerouslySetInnerHTML={description ? { __html: description } : undefined}
            />
            {footer && (
                <Typography fontWeight={600} mb={1.5} color="text.secondary">
                    {footer}
                </Typography>
            )}
            <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ borderRadius: 2, fontWeight: 600, fontSize: 16, py: 1.2, mb: 1.5, boxShadow: 'none', textTransform: 'none', color: '#fff' }}
                onClick={onConfirm}
                disabled={loading}
            >
                {loading ? <CircularProgress size={22} sx={{ color: '#fff' }} /> : confirmLabel}
            </Button>
            <Button
                variant="outlined"
                color="primary"
                fullWidth
                sx={{ borderRadius: 2, fontWeight: 600, fontSize: 16, py: 1.2, textTransform: 'none' }}
                onClick={onCancel}
                disabled={loading}
            >
                {cancelLabel}
            </Button>
        </Box>
    </BottomSheetDialog>
);

export default DeletePopupMobile;
